// VALIDATION MESSAGES
export const VALIDATION_MESSAGE = {
  required: "This field is required",
  string:"This field should be a string",
  number:"This field should be a number",
  date:"This field should be a date"
};
// VALIDATION MESSAGES

export const tenant = window.location.host.split(".")[0] || process.env.REACT_APP_LOCAL_TENANT;

export const assigneeTenants = new Set(process.env.REACT_APP_DOCGEN_ASSIGNEE_TENANTS?.split(",") || []);

export const inventorFormCodes = ["AIA-01", "AIA-02", "AIA-03", "AIA-04", "AIA-05", "AIA-08", "AIA-09"];

export const applicantFormCodes = ["AIA-96"];

export const contactFormCodes = [...inventorFormCodes, ...applicantFormCodes];

export const DateFormatsOptions = ["YYYY-MM-DD", "MMMM DD, YYYY", "DD MMMM, YYYY",  "DD/MM/YYYY", "MM/DD/YYYY", "MM/DD/YY", "DD-MMM-YYYY", "DD-MMM-YY", "DD-MM-YYYY", "DD-MM-YY", "MM-DD-YYYY", "MM-DD-YY"];

export const FormTypeOptions = [
    {
        value: "standard",
        label: "Standard"
    },
    {
        value: "custom",
        label: "Custom"
    }
]

export const PriorApplicationStatusOptions = [
    {
        value: "Abandoned",
        label: "Abandoned"
    },
    {
        value: "Allowed",
        label: "Allowed"
    },

    {
        value: "Expired",
        label: "Expired"
    },
    {
        value: "Issued",
        label: "Issued"
    },
    {
        value: "Pending",
        label: "Pending"
    },
    {
        value: "Published",
        label: "Published"
    },
    {
        value: "Reissued",
        label: "Reissued"
    },
    {
        value: "Transferred",
        label: "Transferred"
    },
    {
        value: "Unfiled",
        label: "Unfiled"
    }
]